<mat-toolbar role="heading">
  <!-- left side of toolbar -->
  <button mat-icon-button (click)="toggleSideNav.emit()">
    <mat-icon>list</mat-icon>
  </button>
  <span class="mobile-disable">
    {{ headerService.currentHeadlineBase + " -&nbsp;" }}
  </span>
  <span>
    {{ headerService.currentHeadLineExtension }}
  </span>

  <!-- spacer to separate left and right side of toolbar -->
  <span class="toolbar-spacer"></span>

  <!-- right side of toolbar -->
  @if (loginService.isLoggedIn()) {
    <span>{{ userInitial }}</span>
  }
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="loginService.logout()">
      <mat-icon>logout</mat-icon>
      <span>{{ "components.header-section.logout" | translate }}</span>
    </button>
    <mat-radio-group
      aria-label="Select an option"
      [(ngModel)]="language"
      (change)="updateLanguage()"
    >
      <mat-radio-button value="de">DE</mat-radio-button>
      <mat-radio-button value="en">EN</mat-radio-button>
    </mat-radio-group>
  </mat-menu>
</mat-toolbar>
